import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { AnimationOnPageLoadContext } from './AnimationOnPageLoadGroup';

const Styled = styled.div`
  opacity: 0;
`;

class AnimationOnPageLoadItem extends React.PureComponent {
  static propTypes = {
    onMount: PropTypes.func,
  };

  componentDidMount() {
    this.props.onMount(this.containerNode);
  }

  render() {
    const { children } = this.props;

    return (
      <Styled data-animation innerRef={node => (this.containerNode = node)}>
        {children}
      </Styled>
    );
  }
}

const AnimationOnPageLoadItemConnected = props => (
  <AnimationOnPageLoadContext.Consumer>
    {({ registerNode }) => <AnimationOnPageLoadItem onMount={registerNode} {...props} />}
  </AnimationOnPageLoadContext.Consumer>
);

export default AnimationOnPageLoadItemConnected;



// WEBPACK FOOTER //
// ./src/components/AnimationOnPageLoadItem.js